import { Editor } from "@tiptap/core";
import { Node as ProseMirrorNode } from "prosemirror-model";

export class AudioView {
  node: ProseMirrorNode;
  editor: Editor;
  getPos: () => number;
  dom: HTMLElement;
  audio: HTMLAudioElement;

  constructor(node: any, editor: any, getPos: any) {
    this.node = node;
    this.editor = editor;
    this.getPos = getPos;

    // 1. Container
    this.dom = document.createElement("div");
    
    // 2. Audio Element
    const wrapper = document.createElement("div");
    wrapper.className = "audio-wrapper";
    
    this.audio = document.createElement("audio");
    this.audio.controls = true;
    this.audio.preload = "metadata";
    this.audio.style.width = "300px";
    this.audio.style.display = "block";
    
    wrapper.appendChild(this.audio);
    this.dom.appendChild(wrapper);

    this.render();
  }

  render() {
    const { src, align } = (this.node as any).attrs;
    const selected = this.editor.state.selection.from === this.getPos();

    // Sync Source
    if (this.audio.src !== src) {
      this.audio.src = src || "";
    }

    // Alignment & Selection Classes
    const alignmentClass = `align-${align || 'center'}`;
    const selectionClass = selected ? "ProseMirror-selectednode" : "";
    this.dom.className = `audio-node audio-block ${alignmentClass} ${selectionClass}`;

    this.renderToolbar(selected);
  }

  renderToolbar(selected: boolean) {
    this.dom.querySelector(".audio-toolbar")?.remove();
    if (!selected) return;

    const toolbar = document.createElement("div");
    toolbar.className = "audio-toolbar";

    ["left", "center", "right"].forEach((dir) => {
      const btn = document.createElement("button");
      btn.innerText = dir.charAt(0).toUpperCase() + dir.slice(1);
      btn.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.editor.chain().focus().updateAttributes("audio", { align: dir }).run();
      };
      toolbar.appendChild(btn);
    });

    const delBtn = document.createElement("button");
    delBtn.innerText = "Delete";
    delBtn.style.color = "red";
    delBtn.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.editor.chain().focus().deleteSelection().run();
    };
    toolbar.appendChild(delBtn);

    this.dom.prepend(toolbar);
  }

  update(node: any) {
    if (node.type !== this.node.type) return false;
    this.node = node;
    this.render();
    return true;
  }

  selectNode() { this.render(); }
  deselectNode() { this.render(); }
}